import React, { useEffect, useState } from "react";
import Logo from "../../css/logo1.png";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "../../components/Form/index";
import usePasswordToggle from "../../hooks copy/usePasswordToggle";
import logo from "../../Assests/image/logo.png";
import { loginApi } from "../../services/auth/Auth";
import { toastMessage } from "../../utils/toastMessage";
import useButtonLoader from "../../hooks/UseButtonLoader";
import { regex } from "../../utils/regex";
import commonMessages from "../../utils/commonMessages";
import { auth, dashboard } from "../../routes/route";
import { getDataFromLocal } from "../../config/config";
import { useDispatch } from "react-redux";
import { setRightsInfo, setRole } from "../../utils/store/slices/rightsSlice";
import { normalizeRightsBooleans } from "../../utils/normalizeRights";
import { routes } from "../../routes/Sidebar";
const {
  EMAIL_NOT_FOUND,
  PASSWORD_NOT_FOUND,
  VALID_EMAIL,
  VALID_PASSWORD,
} = commonMessages;
const { FORGET_PASSWORD_ROUTE } = auth;
const { DASHBOARD, DASHBOARD_2 } = dashboard;

const postLoginPath = (role, rights) => {
  const r = rights || {};
  if (String(role || "").trim().toLowerCase() === "admin") return DASHBOARD;
  if (r["dashboard-management"] === true) return DASHBOARD;
  if (r["marketing-dashboard-management"] === true) return DASHBOARD_2;
  // Sub-admin fallback: send to the first route they actually have access to.
  const firstAllowed = routes(r, role)?.[0]?.path;
  return firstAllowed || DASHBOARD;
};

const Login = () => {
  const token = getDataFromLocal("vedic_token");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { email, password } = regex;

  const [inputType, Icon] = usePasswordToggle("small");
  const [buttonref, buttonLoader] = useButtonLoader("Login");
  const [error, setError] = useState({});
  const [otpPhoneStep, setOtpPhoneStep] = useState(false);
  const [otpPhoneOptions, setOtpPhoneOptions] = useState([]);
  const [selectedOtpPhone, setSelectedOtpPhone] = useState("");
  const [otpStep, setOtpStep] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [maskedMobile, setMaskedMobile] = useState("");

  const [loginValue, setLoginValue] = useState({
    email: "",
    password: "",
  });

  const handleValidation = () => {
    const error = {};
    let status = true;

    if (!loginValue.email) {
      error["email"] = EMAIL_NOT_FOUND;
      status = false;
    }
    if (!loginValue.email.match(email)) {
      error["matchEmail"] = VALID_EMAIL;
      status = false;
    }

    if (!loginValue.password) {
      error["password"] = PASSWORD_NOT_FOUND;
      status = false;
    }

    // if (!loginValue.password.match(password)) {
    //   error['matchPassword'] = VALID_PASSWORD
    //   status = false
    // }

    setError(error);
    return status;
  };

  const handleOtpPhoneValidation = () => {
    const error = {};
    let status = true;

    if (!selectedOtpPhone) {
      error["otpPhone"] = "Please select OTP mobile number";
      status = false;
    }

    setError(error);
    return status;
  };

  const handleOtpValidation = () => {
    const error = {};
    let status = true;

    if (!otpValue.trim()) {
      error["otp"] = "OTP is required";
      status = false;
    } else if (!/^\d{4,6}$/.test(otpValue.trim())) {
      error["otp"] = "Please enter valid OTP";
      status = false;
    }

    setError(error);
    return status;
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setLoginValue({ ...loginValue, [name]: value });
    if (otpPhoneStep || otpStep) {
      setOtpPhoneStep(false);
      setOtpPhoneOptions([]);
      setSelectedOtpPhone("");
      setOtpStep(false);
      setOtpValue("");
      setMaskedMobile("");
    }
  };

  const getMaskedMobile = (mobile = "") => {
    if (String(mobile || "").includes("*")) return mobile;
    const digits = String(mobile || "").replace(/\D/g, "");
    if (!digits) return "";
    return `******${digits.slice(-4)}`;
  };

  const completeLogin = (data) => {
    localStorage.setItem("vedic_token", data?.result?.token);
    localStorage.setItem("vedic_email", data?.result?.email);
    localStorage.setItem("vedic_mobile", data?.result?.mobile || "");
    localStorage.setItem("vedic_role", data?.result?.role || "admin");
    const rightsNorm = normalizeRightsBooleans(data?.result?.rights || {});
    localStorage.setItem("vedic_rights", JSON.stringify(rightsNorm));
    dispatch(setRightsInfo({ rightsInfo: rightsNorm }));
    dispatch(setRole({ role: data?.result?.role }));

    navigate(postLoginPath(data?.result?.role, rightsNorm));
  };

  const admiLogin = async (e) => {
    e.preventDefault();
    const isValid = otpStep
      ? handleOtpValidation()
      : otpPhoneStep
      ? handleOtpPhoneValidation()
      : handleValidation();
    if (isValid) {
      try {
        buttonLoader(true);
        const payload = otpStep
          ? { ...loginValue, otp: otpValue.trim(), otpPhoneKey: selectedOtpPhone }
          : otpPhoneStep
          ? { ...loginValue, otpPhoneKey: selectedOtpPhone }
          : loginValue;
        const { data } = await loginApi(payload);
        if (data.code === 202 && data?.otpSelectionRequired) {
          setOtpPhoneStep(true);
          setOtpStep(false);
          setOtpPhoneOptions(data?.result?.otpPhones || []);
          setSelectedOtpPhone("");
          setOtpValue("");
          setMaskedMobile("");
          toastMessage(data.message || "Password verified", "success", "adminLoginOtpSelect");
          return;
        }

        if (data.code === 202 && data?.otpRequired) {
          setOtpPhoneStep(false);
          setOtpStep(true);
          setOtpValue("");
          setMaskedMobile(getMaskedMobile(data?.result?.mobile));
          toastMessage(data.message || "OTP sent successfully", "success", "adminLoginOtp");
          return;
        }

        if (data.code === 200) {
          completeLogin(data);
        } else {
          toastMessage(data.message, "error", "adminLogin");
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        buttonLoader(false);
      }
    }
  };

  useEffect(() => {
    if (token) {
      // setAuthToken(token)
      navigate(
        postLoginPath(
          localStorage.getItem("vedic_role"),
          normalizeRightsBooleans(
            JSON.parse(localStorage.getItem("vedic_rights") || "{}")
          )
        )
      );
    }
  }, [token]);

  return (
    <>
      <div className="LoginArea">
        <h1 className="login_head">Vedic Meet</h1>
        <div className="LoginBox">
          <figure className="company_logo">
            <img src={logo} alt={"This is company logo"} />
          </figure>
          <h5 className="mt-2">Login here</h5>
          <form>
            <div className="form-group">
              <Input
                label={"Email ID"}
                type="text"
                name="email"
                value={loginValue.email}
                onChange={onChangeHandler}
                disabled={otpPhoneStep || otpStep}
                placeholder="Enter Email"
                className={`form-control `}
                error={
                  !loginValue.email
                    ? error.email
                    : !loginValue.email.match(email) && error.matchEmail
                }
                maxLength={40}
                leftIcon={
                  <span className="Icon">
                    <i className="fa fa-envelope" />
                  </span>
                }
              />
            </div>

            <div className="form-group">
              <Input
                type={inputType}
                name="password"
                value={loginValue.password}
                onChange={onChangeHandler}
                disabled={otpPhoneStep || otpStep}
                placeholder="Enter Password"
                className={`form-control `}
                label={"Password"}
                // error={
                //   !loginValue.password
                //     ? error.password
                //     : !loginValue.password.match(password) &&
                //       error.matchPassword
                // }
                error={!loginValue.password && error.password}
                maxLength={15}
                leftIcon={
                  <span className="Icon">
                    <i className="fa fa-unlock-alt" />
                  </span>
                }
              />
              <span className="icon">{Icon}</span>
            </div>

            {otpPhoneStep && (
              <div className="form-group">
                <label className="my-1 text-dark">Select OTP Number</label>
                <select
                  className={`form-control ${error.otpPhone ? "is-invalid" : ""}`}
                  value={selectedOtpPhone}
                  onChange={(event) => setSelectedOtpPhone(event.target.value)}
                >
                  <option value="">Select Number</option>
                  {otpPhoneOptions.map((option) => (
                    <option key={option.key} value={option.key}>
                      {option.label} ({option.maskedMobile})
                    </option>
                  ))}
                </select>
                {error.otpPhone && (
                  <div className="invalid-feedback">{error.otpPhone}</div>
                )}
              </div>
            )}

            {otpStep && (
              <div className="form-group">
                <Input
                  label={"OTP"}
                  type="text"
                  name="otp"
                  value={otpValue}
                  onChange={(event) =>
                    setOtpValue(event.target.value.replace(/\D/g, "").slice(0, 6))
                  }
                  placeholder="Enter OTP"
                  className={`form-control `}
                  error={error.otp}
                  maxLength={6}
                  leftIcon={
                    <span className="Icon">
                      <i className="fa fa-key" />
                    </span>
                  }
                />
                {maskedMobile && (
                  <small className="text-muted">OTP sent to {maskedMobile}</small>
                )}
              </div>
            )}

            <div className="Checkboxs">
              {otpPhoneStep || otpStep ? (
                <button
                  type="button"
                  className="btn btn-link p-0"
                  onClick={() => {
                    setOtpPhoneStep(false);
                    setOtpPhoneOptions([]);
                    setSelectedOtpPhone("");
                    setOtpStep(false);
                    setOtpValue("");
                    setMaskedMobile("");
                    setError({});
                  }}
                >
                  Change email or password
                </button>
              ) : (
                <Link to={FORGET_PASSWORD_ROUTE}>forgot password?</Link>
              )}
            </div>

            <div className="form_btn">
              <button className="login_btn" ref={buttonref} onClick={admiLogin}>
                {otpStep ? "Verify OTP" : otpPhoneStep ? "Send OTP" : "Log In"} <i className="fa fa-sign-in"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
